<template>
  <div class="bg-white jumbotron m-b-0" :class="{'p-b-0':noPadding}">
    <img class="wd-120" v-if="content.img" :src="content.img" alt="">
    <h1 class="font-40"  v-if="content.title">
      {{content.title}}
    </h1>
    <p class="font-18"  v-if="content.text">
      <span v-html="content.text"></span>
    </p>
    <hr class="my-4">
    <p  v-if="content.intro">
      <span v-html="content.intro"></span>
    </p>
    <b-btn variant="primary" @click="jump(content.btnLink)"  v-if="content.btnText">{{content.btnText}}</b-btn>
    <b-btn variant="success" @click="jump(content.btnLink2)" v-if="content.btnText2">{{content.btnText2}}</b-btn>
    <p class="m-t-20 pointer" @click="jump(content.anchorLink)" v-if="content.isanchor">
      <span>{{content.isanchor}}</span><span>{{content.anchorText}}</span>
    </p>
    <div class="qrcode" @click.self="close" v-show='show'>
      <div >
        <div v-show="!step">
          <b-alert show variant="danger" class="m-b-50" >{{subTxt}}</b-alert>
          <h3 class="font-light m-b-30 text-center">填写<strong class="text-danger">真实姓名、身份证号码</strong>进行实名认证</h3>
          <div class="text-left mauto">
            <b-form-group  :required="true" :class="[errors.has('name')?'has-danger has-error':'']" label="真实姓名" label-for="name" labelTextAlign="right" :label-cols="4" :horizontal="true">
              <b-form-input class='w-180' v-model="name" name="name" v-validate="'required|verify_realname'" maxlength="20" id="name" type="text" placeholder="真实姓名"></b-form-input>
              <span class="control-label" :class="{'color-danger':errors.has('name')}">{{errors.first('name') | errorFilter('真实姓名')}}</span>
            </b-form-group>
            <b-form-group :required="true" :class="[errors.has('idCard')?'has-danger has-error':'']" label="身份证号码" label-for="idCard" labelTextAlign="right" :label-cols="4" :horizontal="true">
              <b-form-input class='w-240' v-model="idCard" name="idCard" v-validate="'required|verify_identity'" minlength="18" maxlength="18" id="idCard" type="text" placeholder="身份证号码"></b-form-input>
              <span class="control-label" :class="{'color-danger':errors.has('idCard')}">{{errors.first('idCard') | errorFilter('身份证号码')}}</span>
            </b-form-group>
          </div>
          <b-button variant="primary" size="md" @click="verify" class="mauto db m-t-30">提交</b-button>
        </div>
        <div class="text-center" v-show="step" >
          <b-alert show variant="danger" class="m-b-50" >{{subTxt}}</b-alert>
          <h3 class="font-light">使用支付宝 <strong class="text-danger">实名认证</strong></h3>
          <div class="qrbox">
            <img :src="tips" alt="">
            <div class="qr">
              <vue-qr :text="text"  :autoColor="true" :logoSrc="logo" :size="140" :margin="0" :dotScale="1"></vue-qr>
            </div>
          </div>
          <p class="m-b-5">使用手机支付宝 扫描二维码认证</p>
          <p class="text-muted">实名认证不涉及金钱账户，认证信息将被严格保密</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userService from 'service/user-service'
  import VueQr from 'vue-qr'
  import { mapGetters } from 'vuex'
  export default {
    name: 'compinents-custom-prompt-box',
    data () {
      return {
        show: false,
        text: 'https://my.offerago.com',
        logo: require('assets/img/logo-min.png'),
        tips: require('assets/img/zfbsys.jpg'),
        step: false,
        name: '',
        idCard: '',
        subTxt: '根据国家有关法律法规及相关政策，升级成为主播前请先进行实名认证',
        t: null,
        path: '',
        biz: ''
      }
    },
    components: {VueQr},
    computed: {
      ...mapGetters(['roles'])
    },
    props: {
      content: {
        type: Object
      },
      noPadding: {
        type: Boolean,
        default: false
      }
    },
    beforeDestroy () {
      clearInterval(this.t)
    },
    beforeRouteLeave (to, from, next) {
      clearInterval(this.t)
      this.t = null
      next()
    },
    methods: {
      getBiz () {
        userService.getBizNo({bizNo: this.biz}).then(r => {
          if (r) {
            if (r.data.bizStatus === 'init') {
              return false
            } else if (r.data.bizStatus === 'error') {
              this.$awn.warning(r.data.failedReason)
              clearInterval(this.t)
              this.name = ''
              this.idCard = ''
              this.biz = ''
              this.step = false
            } else if (r.data.bizStatus === 'success') {
              clearInterval(this.t)
              this.$awn.success('恭喜您完成实名认证，正在跳转。。。')
              this.$router.replace(this.path)
            }
          }
        })
      },
      verify () {
        this.$validator.validateAll().then(
          success => {
            if (!success) {
              this.$awn.alert('请修改错误后再提交表单')
            } else {
              userService.identityVerified({
                user: {
                  identityNo: this.idCard,
                  realName: this.name
                }
              }).then(r => {
                if (r) {
                  if (r.meta.success) {
                    userService.bizNo().then(res => {
                      if (res) {
                        if (res.meta.success) {
                          this.biz = res.data.bizNo
                          userService.certifyQr({bizNo: res.data.bizNo}).then(response => {
                            if (response) {
                              if (response.meta.success) {
                                this.text = response.data.certifyUrl
                                this.step = true
                                this.t = setInterval(this.getBiz, 1000)
                              }
                            }
                          })
                        } else {
                          return false
                        }
                      } else {
                        return false
                      }
                    })
                  } else {
                    this.$awn.info(r.meta.message)
                  }
                }
              })
            }
          }, fail => {

          })
      },
      close () {
        this.show = false
        clearInterval(this.t)
        this.step = false
        this.name = ''
        this.idCard = ''
        this.biz = ''
      },
      jump (path) {
        this.path = path
        console.log("TCL: jump -> path", path)
        if (path.indexOf('student') < 0) {
          if (path.indexOf('company') >= 0) {
            this.subTxt = '根据国家法律法规及相关政策，企业入驻前需要进行实名认证'
            userService.info().then(r => {
              if (r) {
                if (r.meta.success) {
                  if (!r.data.user.identityVerified) {
                    this.show = true
                  } else {
                    this.$router.push(path)
                  }
                }
              }
            })
          } else if (path.indexOf('anchor') >= 0) {
            userService.info().then(r => {
              if (r) {
                if (r.meta.success) {
                  if (!r.data.user.identityVerified) {
                    this.show = true
                  } else {
                    this.$router.push(path)
                  }
                }
              }
            })
          } else {
            this.$router.push(path)
          }
        } else {
          this.$router.push(path)
        }
      }
    },
    created() {
      const verifyRealname = {
        getMessage: field => `姓名格式错误！`,
        validate: value => {
          let flag = /^[\u4e00-\u9fa5]{2,6}$/.test(value)
          if (!flag) {
            return flag
          }
          return {valid: true}
        }
      }
      this.$validator.remove('verify_realname')
      this.$validator.extend('verify_realname', verifyRealname)
      const verifyIdentity = {
        getMessage: field => `身份证格式错误！`,
        validate: value => {
          let flag = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)
          if (!flag) {
            return flag
          }
          return {valid: true}
        }
      }
      this.$validator.remove('verify_identity')
      this.$validator.extend('verify_identity', verifyIdentity)
    }
  }
</script>

<style lang='scss' scoped>
.wd-120{
  width: 120px;
  margin-bottom: 30px;
}
.w-180{
  width:180px;
}
.w-240{
  width:240px;
}
.color-white{
  color: #fff;
  &:hover{
    color: #fff;
  }
}
.qrcode{
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: rgba(0,0,0,.8);
  &>div{
    width: 600px;
    height: 480px;
    padding: 20px;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  .qrbox{
    width: 340px;
    margin: 0 auto;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .qr{
      width: 160px;
      height: 160px;
      padding: 10px;
      border: 1px solid #eee;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/prompt-box/prompt-box.vue